import _asyncToGenerator from "/home/runner/work/mainrepo/mainrepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { isE2E, takeWhileAlive } from '../../utils';
import { filter, firstValueFrom, take } from 'rxjs';
import { FeatureRouterLinkResolverService } from '../../feature/router-link-resolver/feature-router-link-resolver.service'; // deep to fix circular dependency!
import { AccessState } from './access.state';
import { AccessService } from './access.service';
import { AccessServiceState } from '@core/shared/access';
import * as i0 from "@angular/core";
import * as i1 from "./access.service";
import * as i2 from "@angular/router";
import * as i3 from "../../feature/router-link-resolver/feature-router-link-resolver.service";
const ROUTE_DATA_ACCESS_KEY = 'access';
export function accessGuardData(requirement, options = {}) {
  const data = {
    requirement,
    options
  };
  return {
    [ROUTE_DATA_ACCESS_KEY]: data
  };
}
export let AccessGuard = /*#__PURE__*/(() => {
  class AccessGuard {
    constructor(access, router, routerLinkResolver) {
      this.access = access;
      this.router = router;
      this.routerLinkResolver = routerLinkResolver;
      this.loggedIn$ = inject(Store).select(AccessState.loggedIn);
      this.loggedIn$.pipe(takeWhileAlive()).subscribe(loggedIn => this.loggedIn = loggedIn);
    }
    canActivate(route, state) {
      var _this = this;
      return _asyncToGenerator(function* () {
        // It is necessary to wait until end of event loop, so route and state have their final state
        yield new Promise(resolve => setTimeout(resolve));
        if (_this.access.isSU) return true;
        return _this.checkAccess(route);
      })();
    }
    canLoad(route) {
      var _this2 = this;
      return _asyncToGenerator(function* () {
        if (_this2.access.isSU) return true;
        return _this2.checkAccess(route);
      })();
    }
    checkAccess(route) {
      var _this3 = this;
      return _asyncToGenerator(function* () {
        if (_this3.access.status !== AccessServiceState.READY) {
          yield firstValueFrom(_this3.access.status$.pipe(filter(status => status === AccessServiceState.READY), take(1)));
        }
        const data = route.data[ROUTE_DATA_ACCESS_KEY];
        const allowed = _this3.access.simpleAbilityCheck(data.requirement);
        if (!allowed) {
          yield _this3.executeRedirect(_this3.router, route, data);
        }
        return allowed;
      })();
    }
    executeRedirect(router, route, data) {
      var _this4 = this;
      return _asyncToGenerator(function* () {
        const redirect = data.options?.redirectTo || (yield _this4.getDefaultRedirectTo(route));
        const redirectTo = typeof redirect === 'function' ? redirect(route) : redirect;
        if (isE2E()) {
          const redirectString = Array.isArray(redirectTo) ? redirectTo.join('/') : redirectTo;
          console.warn('AccessGuard redirect to ' + redirectString + ' because of failed check: ', data.requirement);
        }
        // if (isRedirectionWithParameters(redirectTo)) {
        // 	this.router.navigate(redirectTo.navigationCommands, redirectTo.navigationExtras);
        // 	return;
        // }
        if (Array.isArray(redirectTo)) router.navigate(redirectTo);else router.navigate([redirectTo]);
      })();
    }
    getDefaultRedirectTo(route) {
      var _this5 = this;
      return _asyncToGenerator(function* () {
        let loggedIn = yield firstValueFrom(_this5.loggedIn$);
        let link;
        if (!loggedIn) {
          // if a visitor is not logged in at all, we want to redirect to login.
          link = _this5.routerLinkResolver.resolveRouterLink('login', true);
        } else {
          // user is logged in but has no access to the requested route. Redirect to error page.
          link = _this5.routerLinkResolver.resolveRouterLink('error-403', true);
        }
        return link;
      })();
    }
    static {
      this.ɵfac = function AccessGuard_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AccessGuard)(i0.ɵɵinject(i1.AccessService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.FeatureRouterLinkResolverService));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: AccessGuard,
        factory: AccessGuard.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AccessGuard;
})();